module.exports = __webpack_public_path__ + "img/gzh.0a4bf5e2.png";